import PriceHistory from './graphs/price-history/index'

if (!window._showcaseGraphs) {
    window._showcaseGraphs = { PriceHistory }
}